export default {
  stripePubKey: process.env.NODE_ENV === "development" ? "pk_test_lOV3RkmgVAhJ68IFokI4ikla" : "pk_live_t7kVKi6a8PewGzPgwS8BQJNR",
};
